import React from 'react';
import { motion } from 'framer-motion';
import { TwitterIcon, LinkedinIcon, YoutubeIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
const SocialsPage = () => {
  const socialLinks = [{
    name: 'Twitter',
    url: 'https://twitter.com/aakashg',
    icon: <TwitterIcon size={24} data-id="element-519" />,
    color: 'bg-blue-400',
    username: '@aakashg'
  }, {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/in/aagupta/',
    icon: <LinkedinIcon size={24} data-id="element-520" />,
    color: 'bg-blue-700',
    username: 'aagupta'
  }, {
    name: 'YouTube',
    url: 'https://youtube.com/@growproduct',
    icon: <YoutubeIcon size={24} data-id="element-521" />,
    color: 'bg-red-600',
    username: '@growproduct'
  }, {
    name: 'Instagram',
    url: 'https://www.instagram.com/aakashg0/',
    icon: <InstagramIcon size={24} data-id="element-522" />,
    color: 'bg-pink-600',
    username: '@aakashg0'
  }, {
    name: 'Website',
    url: 'https://aakashg.com',
    icon: <GlobeIcon size={24} data-id="element-523" />,
    color: 'bg-gray-700',
    username: 'aakashg.com'
  }];
  return <div className="bg-white min-h-screen" data-id="element-524">
      <div className="container mx-auto px-4 py-16" data-id="element-525">
        <motion.h1 className="text-4xl font-bold text-center text-gray-800 mb-8" initial={{
        opacity: 0.5
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5
      }} data-id="element-526">
          Connect With Me
        </motion.h1>
        <motion.p className="text-xl text-center text-gray-700 mb-12 max-w-2xl mx-auto" initial={{
        opacity: 0.5
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-527">
          Follow me on social media for product insights, growth strategies, and
          behind-the-scenes content.
        </motion.p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-4xl mx-auto" data-id="element-528">
          {socialLinks.map((social, index) => <motion.a key={social.name} href={social.url} target="_blank" rel="noopener noreferrer" className="bg-white rounded-lg shadow-lg p-6 flex items-center hover:shadow-xl transition-shadow" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.98
        }} data-id="element-529">
              <div className={`${social.color} text-white p-4 rounded-full mr-4`} data-id="element-530">
                {social.icon}
              </div>
              <div data-id="element-531">
                <h3 className="text-xl font-bold text-gray-800" data-id="element-532">
                  {social.name}
                </h3>
                <p className="text-gray-600" data-id="element-533">{social.username}</p>
              </div>
            </motion.a>)}
        </div>
        <motion.div className="mt-16 bg-gray-50 p-8 rounded-lg max-w-2xl mx-auto" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} data-id="element-534">
          <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-535">
            Let's Connect
          </h3>
          <p className="text-gray-700 mb-6" data-id="element-536">
            I'm always open to discussing product strategy, growth
            opportunities, or potential speaking engagements. Feel free to reach
            out!
          </p>
          <div className="flex justify-center" data-id="element-537">
            <motion.a href="mailto:productgrowthppp@gmail.com" className="px-6 py-3 bg-[#0FB9B1] text-white rounded-md font-medium hover:bg-[#0ca69e] transition-colors" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-538">
              Email Me
            </motion.a>
          </div>
        </motion.div>
      </div>
    </div>;
};
export default SocialsPage;